import { isFunction } from '@agilepoint/utils-common';
import { PickKeysOfType } from '@agilepoint/utils-type';
import React, { useCallback } from 'react';
import * as editorAPI from 'roosterjs-editor-api';
import { FormatState, IEditor } from 'roosterjs-editor-types';
import { IIconProps } from '../../../icon';
import { useToolbarActionContext, useFormatState } from '../context';
import { CommandButton } from './command-button';
import { IEditorToolbarActionBaseProps } from './types';

interface ISimpleActionBuilderOptions extends Pick<IIconProps, 'iconName' | 'iconSize'> {
    action?: PickKeysOfType<typeof editorAPI, (editor: IEditor) => void>;
    activeStatePropName?: PickKeysOfType<FormatState, boolean>;
    label?: string;
    tooltip?: string;
    isDisabled?(formatState: FormatState): boolean;
    isHidden?(formatState: FormatState): boolean;
    onTriggerAction?(editor: IEditor): void;
}

const defaultIsHiddenFuntion = () => false;
const defaultIsDisabledFuntion = () => false;

export function createSimpleAction(options: ISimpleActionBuilderOptions) {
    const {
        activeStatePropName, action, label, tooltip, iconName, iconSize,
        onTriggerAction, isHidden = defaultIsHiddenFuntion, isDisabled = defaultIsDisabledFuntion
    } = options;
    const SimpleAction = (props: IEditorToolbarActionBaseProps) => {
        const { editor } = useToolbarActionContext();
        const formatState = useFormatState();

        const _onClick = useCallback(() => {
            if (isFunction(onTriggerAction)) {
                onTriggerAction(editor);
                return;
            }
            if (!action) {
                return;
            }
            editorAPI[action](editor);
        }, [editor]);

        const isActive = activeStatePropName ? formatState[activeStatePropName] : false;

        return (
            <CommandButton {...props} hidden={isHidden(formatState)} $disabled={isDisabled(formatState)}
                onClick={_onClick} title={label} $isActive={isActive} tooltip={tooltip}
                iconName={iconName} iconSize={iconSize} />
        );
    };

    SimpleAction.displayName = label ?? tooltip;

    return SimpleAction;
}
